/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_DASHBOARD, ICON_FOLDER_COPY, NavigationItem } from '@squiz/sds';
import React from 'react';
import { DamDashboard } from '../Screens/DamDashboard/DamDashboard';
import { FileStore } from '../Screens/FileStore/FileStore';
import { screenPaths } from './ScreenPaths.constants';
import { DAM_STRINGS } from './Strings.constants';

/**
 * Digital asset management dashboard.
 */
export const DAM_DASHBOARD: NavigationItem = {
  icon: ICON_DASHBOARD,
  key: 'digital-asset-management-dashboard',
  label: DAM_STRINGS.dashboard,
  path: screenPaths.dashboard,
  screen: <DamDashboard />,
};

/**
 * File store screen.
 */
export const FILE_STORE_SCREEN: NavigationItem = {
  icon: ICON_FOLDER_COPY,
  key: `file-store`,
  label: DAM_STRINGS.fileStore,
  path: screenPaths.fileStore,
  screen: <FileStore />,
};
